import { render } from "./Footer.vue?vue&type=template&id=0fbd1cb1&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0fbd1cb1&scoped=true&lang=scss"

import exportComponent from "/home/nasu/nodejs/syakkinsoudan/ikeda-line/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbd1cb1"]])

export default __exports__